import Badge from '@anm/components/Badge';
import SocialAvatar from '@anm/components/SocialAvatar';
import getFromCdn from '@anm/helpers/getFromCdn';
import { FC } from 'react';

import { BudgesContainer, DestinationInfoRow, InfoContainer, Subtitle, Title, TitleAndBadgeRow } from '../../Wrapper';
import getDestinationInfo from '../../helpers';
import { DestinationInfoProps } from '../../types';

const defaultRTMPImage = 'images/icons/default_avatar.svg';

const DestinationInfo: FC<DestinationInfoProps> = ({
  kind,
  size,
  title,
  avatar,
  network,
  isDisconnected,
  iconVariant = '50x50'
}) => {
  const avatarSrc = network === 'RTMP' ? defaultRTMPImage : avatar;

  return (
    <DestinationInfoRow {...{ size }}>
      <SocialAvatar alt={title} kind={kind} network={network} variant={iconVariant} avatarSrc={avatarSrc} />
      <InfoContainer>
        <Title title={title} level={3} />
        <TitleAndBadgeRow>
          <Subtitle>{getDestinationInfo({ kind, title, network })}</Subtitle>
          {isDisconnected && (
            <BudgesContainer>
              <Badge variant="light-red" icon={getFromCdn('images/icons/disconnect-icon.svg')}>
                Disconnected
              </Badge>
            </BudgesContainer>
          )}
        </TitleAndBadgeRow>
      </InfoContainer>
    </DestinationInfoRow>
  );
};
export default DestinationInfo;
